<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BBS_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ bbsName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="frame0.boardTitle"
              placeholder=""
              :disabled="false"
              max-length="100"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_ITEM')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-5">
            <sui-select-box
              v-model="selectedCategory"
              :option-list="categoryOptions"
              placeholder="select"
              required
            />
          </div>
          <div class="col-xs-1" />
          <div class="col-xs-5" />
        </div>
      </div>
      <div class="mrB10" />
      <sui-web-editor
        ref="myEditor"
        :isViewer="false"
        class="width100"
        @loaded="retrieveDetails"
      />
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="this.$options.name"
        :attachDocumentId="attachDocumentId"
        :attachGroupId="'ATG_CLB_BBS_COMMON'"
        :customAttachRestrictionSize="attachRestrictSize"
      />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="validateAnouncementData"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
    </sui-page-contents>
    <sui-page-footer />
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00018', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
    },
    pageInitialData: {
      type: Object,
    },
  },
  data() {
    return {
      isWebEdtrInitialized: false,
      bbsName: 'FAQ',
      bbsId: '',
      noticObjUid: '',
      attachDocumentId: '',
      categoryItemSelected: '',
      viewerContents: 'my view post',
      showRegPopup: false,
      categoryOptions: [],
      selectedCategory: {},
      fileList: [],
      frame0: {
        boardTitle: '',
        editorContent: '',
      },
      applicationUserId: this.$store.getters.userInfo.userName,
      attachRestrictSize: 0,
    };
  },
  computed: {},
  watch: {
    frame0(val) {
      this.frame0 = val;
    },
  },
  datasets: [],
  beforeMount() {
    this.getBBName();
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getBBName() {
      this.bbsName = this.pageInitialData.bbsName;
      this.bbsId = this.pageInitialData.bbsId;
      this.attachRestrictSize = this.pageInitialData.attachRestrictSize;
      this.tbabRestrictSize = this.pageInitialData.tbabRestrictSize;
      this.categoryItems();
    },
    categoryItems() {
      http.request('PGE_CLB_00018', 'DTS_CLB_00050', {
        path: {
          'bulletin-board-id': this.bbsId,
        },
      }).then(res => {
        if (res.data) {
          const optionList = res.data;
          let i;
          for (i = 0; i < optionList.length; i++) {
            optionList[i].label = optionList[i]['bbsCatgItemNm'];
            optionList[i].key = optionList[i]['bbsCatgItemId'];
            delete optionList[i].bbsCatgItemId;
            delete optionList[i].bbsCatgItemNm;
            this.categoryOptions = optionList;
          }
        }
      });
    },
    retrieveDetails() {
      this.frame0.boardTitle = this.pageInitialData.retrieveData[0].noticobjTitle;
      this.bbsCatgGrpItemName = this.pageInitialData.retrieveData[0].bbsId;
      this.attachDocumentId = this.pageInitialData.retrieveData[0].attchDocId;
      this.registeredUserName = this.pageInitialData.retrieveData[0].registrantName;
      this.noticObjUid = this.pageInitialData.retrieveData[0].noticobjUid;
      this.selectedCategory = {
        key: this.pageInitialData.retrieveData[0].bbsCatgItemId,
        label: this.pageInitialData.retrieveData[0].bbsCategoryItemNm,
      };
      this.viewerContents = this.pageInitialData.retrieveData[0].noticObjContent;
      this.$refs.myEditor.setHtml(this.viewerContents);
    },
    onPopupCancelClicked() {
      this.showRegPopup = false;
    },
    getFileListInfo() {
      this.fileList = this.$refs.fileAttacher.getAttachGroupItemListInfo();
      if (this.fileList && this.fileList[0].attachFileList.length < 1) {
        this.attachDocumentId = '';
      } else {
        this.attachDocumentId = this.pageInitialData.retrieveData[0].noticobjUid;
      }
      this.register();
    },
    validateAnouncementData() {
      this.viewerContents = this.$refs.myEditor.getHtml();
      if (!this.frame0.boardTitle) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_TITLE'), null));
        return false;
      }
      if (!this.selectedCategory.key) {
        utils.messageBox('warning',  utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_CATG_GRP_ITEM'), null));
        return false;
      }
      if (!this.viewerContents || this.$refs.myEditor.getText().trim().length===0) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_ALT_ROW_INPUT_CONTENT'), null));
        return false;
      }
      if (!this.checkContentSize()) {
        const msg = utils.strFormat(this.$t('MSG_ALT_SIZE_LIMIT_EXCEEDED'), this.tbabRestrictSize);
        utils.messageBox('warning', msg);
        return false;
      }
      utils.messageBox('confirm', this.$t('MSG_ALT_RGST'), null, this.getFileListInfo);
    },
    updateLogs(postId, type) {
      const pathParam = {
        'post-id': postId,
      }
      http.request('PGE_CLB_00018', 'DTS_CLB_00061', {
        path: pathParam,
        data: {
          firstRegistrationProgramId: 'PGE_CLB_00016',
          bbsLogTypeCd: type,
          bbsId: this.bbsId,
          bbsLogDeptId: this.$store.getters.userInfo.departmentId,
          firstRegistrationUserId: this.$store.getters.userInfo.epid,
        },
      }).then(() => {});
    },
    // Get the file info (List of Files)
    register() {
      const dataParams = {
        bbsId: this.bbsId,
        bbsCatgItemId: this.selectedCategory.key,
        noticobjTitle: this.frame0.boardTitle,
        noticObjContent: this.viewerContents,
        noticObjSearchedContent: '0',
        attchDocId: this.attachDocumentId,
        finalModificationUserId: this.$store.getters.userInfo.epid,
        firstRegistrationUserId: this.$store.getters.userInfo.epid,
        bbsLogDeptId: this.$store.getters.userInfo.departmentId,
        attachFileList: this.fileList && this.fileList[0].attachFileList ? this.fileList[0].attachFileList : []
      };
      http.request('PGE_CLB_00018', 'DTS_CLB_00012', {
        path: {
          'post-id': this.noticObjUid,
        },
        data: dataParams,
      })
        .then(res => {
          if (res.data.resultCode) {
            utils.messageBox('information', this.$t('MSG_ALT_PRGS_OK'), null, null);
            this.closePagePopup(true);
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.updateLogs(this.noticObjUid, 'U');
    },
    onCancel() {
      this.closePagePopup(false);
    },
    checkContentSize() {
      return this.tbabRestrictSize >= this.$refs.myEditor.getContentSize();
    },
  },
};
</script>
<style scoped>
</style>